export const THEMES = {
  default: {
    primaryColor: '#73b0eb',
    secondaryColor: '#681c23',
    textOnPrimary: '#007185',
    textOnSecondary: '#007185',
    infoColor: '#681c23',
    cancelColor: '#dc3545'
  },
  navyblue: {
    primaryColor: '#73b0eb',
    secondaryColor: '#681c23',
    textOnPrimary: '#007185',
    textOnSecondary: '#007185',
    infoColor: '#681c23',
    cancelColor: '#dc3545'
  },
  blue: {
    primaryColor: '#085198',
    secondaryColor: '#c7a140',
    textOnPrimary: '#357cc2',
    textOnSecondary: '#357cc2',
    infoColor: '#c7a140',
    cancelColor: '#dc3545'
  },
  green: {
    primaryColor: '#308E89',
    secondaryColor: '#81ae86',
    textOnPrimary: '#007185',
    textOnSecondary: '#007185',
    infoColor: '#295552',
    cancelColor: '#dc3545'
  },
  cyan: {
    primaryColor: '#2a6c98',
    secondaryColor: '#c8a957',
    textOnPrimary: '#007185',
    textOnSecondary: '#007185',
    infoColor: '#c8a857',
    cancelColor: '#dc3545'
  },
  orange: {
    primaryColor: '#ef6c02',
    secondaryColor: '#974300',
    textOnPrimary: '#00589f',
    textOnSecondary: '#007185',
    infoColor: '#703200',
    cancelColor: '#dc3545'
  },
  pink: {
    primaryColor: '#bc00e4d1',
    secondaryColor: '#673ab7',
    textOnPrimary: '#007185',
    textOnSecondary: '#007185',
    infoColor: '#673ab7',
    cancelColor: '#dc3545'
  },

};
